import { render, staticRenderFns } from "./WeekFormTd.vue?vue&type=template&id=b19d12de&scoped=true&"
import script from "./WeekFormTd.vue?vue&type=script&lang=js&"
export * from "./WeekFormTd.vue?vue&type=script&lang=js&"
import style0 from "./WeekFormTd.vue?vue&type=style&index=0&id=b19d12de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19d12de",
  null
  
)

export default component.exports